import React from "react";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DescriptionIcon from "@mui/icons-material/Description";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SettingsIcon from "@mui/icons-material/Settings";
import ScheduleIcon from '@mui/icons-material/Schedule';
import GroupIcon from '@mui/icons-material/Group';
import CompareIcon from '@mui/icons-material/Compare';
import SearchIcon from '@mui/icons-material/Search';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const menus = [  {
    label: "Início",
    type: "section",
    roles: ['admin', 'operador', 'cliente'],
    children: [
      {
        uri: "/dashboard",
        label: "Dashboard",
        type: "nav-item",
        icon: <DashboardIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
  {
    label: "Área do cliente",
    type: 'section',
    roles: ['admin', 'operador', 'cliente'],
    children: [
      {
        uri: "/cliente/processos",
        label: "Meus processos",
        type: "nav-item",
        icon: <SettingsIcon sx={{ fontSize: 20 }} />,
      },
    ]
  },  {
    label: "Marcas",
    type: "section",
    roles: ['admin', 'operador'],
    children: [
      {
        uri: "/marcas/processos",
        label: "Base INPI",
        type: "nav-item",
        icon: <DescriptionIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/marcas/rpi",
        label: "Cadastro",
        type: "nav-item",
        icon: <NewspaperIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/marcas/agenda",
        label: "Agenda",
        type: "nav-item",
        icon: <CalendarMonthIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/marcas/calculadora",
        label: "Calculadora",
        type: "nav-item",
        icon: <AccessTimeIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/marcas/busca",
        label: "Busca",
        type: "nav-item",
        icon: <SearchIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/marcas/colidencias",
        label: "Colidências",
        type: "nav-item",
        icon: <CompareIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/envolvidos",
        label: "Envolvidos",
        type: "nav-item",
        icon: <GroupIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },

  {
    label: "Administração",
    type: "section",
    roles: ['admin'],
    children: [
      {
        uri: "/usuarios",
        label: "Usuários",
        type: "nav-item",
        icon: <AdminPanelSettingsIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/logs-rpis",
        label: "Logs RPIs",
        type: "nav-item",
        icon: <ScheduleIcon sx={{ fontSize: 20 }} />,
      }
    ]
  },
];

export default menus;